import { Injectable, signal } from '@angular/core';
import { LanguageCode } from '@domain/language';

const LANGUAGE_STORAGE_KEY = 'rt-language';

@Injectable({
  providedIn: 'root',
})
export class LanguageStore {
  readonly #language = signal<LanguageCode>(this.getStoredLanguage() || 'ru');

  readonly language = this.#language.asReadonly();

  public setLanguage(language: LanguageCode): void {
    this.#language.set(language);
    localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
  }

  public getStoredLanguage(): LanguageCode {
    return localStorage.getItem(LANGUAGE_STORAGE_KEY) as LanguageCode;
  }
}
